import { Injectable } from '@angular/core';
import { StatusBar } from '@capacitor/status-bar';
import { NavigationBar } from '@hugotomazi/capacitor-navigation-bar';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class EtColoringService {
  private static readonly VITOORANGE = '#ff3e17';
  private static readonly WHITE = '#ffffff';
  private static readonly WHITESMOKE = '#f5f5f5';
  private lastColor: undefined | { statusBarColor: string; navigationColor: string };
  constructor(private platform: Platform) {}

  setPrimaryWhiteColor() {
    this.setColor(EtColoringService.WHITE, EtColoringService.VITOORANGE);
  }

  setPrimaryWhiteSmokeColor() {
    this.setColor(EtColoringService.WHITESMOKE, EtColoringService.VITOORANGE);
  }

  setSecondaryWhiteColor() {
    this.setColor(EtColoringService.WHITE, EtColoringService.WHITE);
  }

  setSecondaryWhiteSmokeColor() {
    this.setColor(EtColoringService.WHITESMOKE, EtColoringService.WHITE);
  }

  async revertColor() {
    if (this.lastColor) {
      await this.setColor(this.lastColor.navigationColor, this.lastColor.statusBarColor);
    }
  }

  private async setColor(navigationColor: string, statusBarColor: string) {
    if (this.platform.is('capacitor')) {
      const lastStatusBarColor = (await StatusBar.getInfo()).color ?? EtColoringService.VITOORANGE;
      const lastNavigationColor = (await NavigationBar.getColor()).color;
      StatusBar.setBackgroundColor({
        color: statusBarColor,
      });
      NavigationBar.setColor({
        color: navigationColor,
      });
      this.lastColor = {
        navigationColor: lastNavigationColor,
        statusBarColor: lastStatusBarColor,
      };
    }
  }
}
